// @owners { team: patients }
import { setOnboardingVerificationChannel, setOnboardingVerificationRequired } from '~shared/actions/verifications';
import type { VerificationCommsChannel } from '~shared/actions/verifications';
import {
  getOnboardingVerificationOptions,
  getOnboardingVerificationUuid,
} from '~shared/features/onboarding/selectors/getOnboardingVerification';
import { useStartVerification } from '~shared/queries/query-keys/verifications';
import { useDispatchShared, useSelectorShared } from '~shared/store';

export type StartOnboardingVerificationValues = {
  channel: VerificationCommsChannel | null | undefined;
};

type Params = {
  readonly onSuccess: () => void;
};

export const useStartOnboardingVerification = ({ onSuccess }: Params) => {
  const dispatch = useDispatchShared();
  const uuid = useSelectorShared(getOnboardingVerificationUuid);
  const options = useSelectorShared(getOnboardingVerificationOptions);
  const { mutateAsync: startVerification, isPending: loading, error } = useStartVerification();

  const onSubmit = async ({ channel: comms_channel }: StartOnboardingVerificationValues) => {
    try {
      await startVerification({
        uuid,
        reason: 'duplicate_account',
        comms_channel,
      });
    } catch {
      // swallow: the mutation's `error` is returned below for the caller to render;
      // there's nothing further for this hook to do on failure
      return;
    }

    dispatch(setOnboardingVerificationRequired());
    dispatch(setOnboardingVerificationChannel(comms_channel));
    onSuccess();
  };

  return { options, onSubmit, loading, error };
};
